module.exports = __webpack_public_path__ + "img/africon_logo.bce0eaf0.png";